import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  outline: none;
  padding: 8px 12px;
  border: 1px solid lightgray;
  border-radius: 4px;
  font-size: 1rem;
  color: gray;
  transition: box-shadow 0.3s;

  &:focus {
    box-shadow: 0 0 0 2px rgb(170, 173, 254, 0.5);
  }
`;
export const InputLoginV2 = styled.input`
  width: 100%;
  outline: none;
  padding: 8px 12px;
  border: 1px solid #ececec;
  border-radius: 12px;
  font-family: poppins;
  font-size: 1rem;
  font-weight: 500;
  font-size: 14px;
  transition: box-shadow 0.3s;
  &::placeholder {
    color: #c1c1c7;
    opacity: 1;
  }
  &:focus {
    box-shadow: 0 0 0 2px rgba(170, 173, 254, 0.5);
  }
`;
